import { Card } from "@/components/Card";
import { H3, P } from "@/components/Typography";
import { getMonthlyMcrMovements } from "@/utils/emailDashboardMetricsHelper";
import { faShieldCheck } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  XAxis,
  YAxis,
  Tooltip,
  TooltipContentProps,
  LineChart,
  Line,
} from "recharts";
import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";

interface IProps {
  data: IGetEmailDashboardRS;
}

const MonthlyMcrMovements = ({ data }: IProps) => {
  const { t } = useTranslation();
  const monthlyMcrMovements = getMonthlyMcrMovements(data?.rawData);

  const getChartTooltip = ({
    active,
    payload,
    label,
  }: TooltipContentProps<ValueType, NameType>) => {
    if (!active || !payload || !payload.length) return null;

    const tickPayload = payload[0];

    return (
      <div className="flex flex-col rounded border border-gray-light bg-white p-10 shadow-sm">
        <span>{label}</span>
        <span
          style={{
            color: tickPayload.color,
          }}>
          {t("email.dashboard.charts.mcr.tooltip")}: {tickPayload.value}%
        </span>
      </div>
    );
  };

  return (
    <Card shadow additionalClassName="p-20 border border-gray-light">
      <div className="flex flex-row items-center gap-10">
        <FontAwesomeIcon
          icon={faShieldCheck}
          className="text-2xl text-primary"
        />
        <H3 className="font-bold">{t("email.dashboard.charts.mcr.title")}</H3>
      </div>
      <P className="mb-20">{t("email.dashboard.charts.mcr.description")}</P>
      <LineChart
        style={{
          width: "100%",
          maxWidth: "700px",
          maxHeight: "70vh",
          aspectRatio: 1.618,
        }}
        responsive
        data={monthlyMcrMovements}>
        <XAxis
          dataKey="name"
          type="category"
          interval="equidistantPreserveStart"
          tick={{ fontSize: 10 }}
        />
        <YAxis
          width="auto"
          tickFormatter={value => `${value}%`}
          tick={{ fontSize: 10 }}
          domain={[0, 100]}
        />
        <Tooltip content={t => getChartTooltip(t)} />
        <Line
          type="monotone"
          dataKey="value"
          stroke="#10A4FF"
          strokeWidth={3}
          dot={false}
        />
      </LineChart>
    </Card>
  );
};

export default MonthlyMcrMovements;
